// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const userProvisionInDisplayNameMax = 200;

export const UserProvisionIn = zod.object({
  "display_name": zod.string().min(1).max(userProvisionInDisplayNameMax),
  "email": zod.email()
});

export type UserProvisionIn = zod.input<typeof UserProvisionIn>;
export type UserProvisionInOutput = zod.output<typeof UserProvisionIn>;
